import { SimulatorLoanConditions } from '@nemuru-eng/checkout-js';
import { LenderName, MoneyDto, PercentDto } from '@nemuru-eng/js-api-client';

import { AutoLoanConditions } from '@/components/modules/Application/components/PaymentMethod/AutoLoan/types/AutoLoanConditions';
import { ConsumerLoanConditionsGroup } from '@/components/modules/Application/components/PaymentMethod/ConsumerLoan/entities/ConditionsGroup/ConsumerLoanConditionsGroup';

export class AutoLoanConditionsGroup extends ConsumerLoanConditionsGroup {
  constructor(public readonly simulatorConditions: SimulatorLoanConditions[]) {
    const conditions = simulatorConditions.map((simulatorCondition): AutoLoanConditions => {
      const condition: AutoLoanConditions = {
        apr: simulatorCondition.apr,
        providerName: simulatorCondition.lenderName,
        pricingId: simulatorCondition.pricingId,
        principal: simulatorCondition.principal,
        annualInterest: simulatorCondition.annualInterest,
        term: simulatorCondition.term,
        setupFeeType: simulatorCondition.setupFeeType,
        setupFee: simulatorCondition.setupFeeAmount,
        gracePeriod: simulatorCondition.gracePeriod,
        gracePercentage: simulatorCondition.gracePercentage,
        instalmentTotalAmount: simulatorCondition.instalmentTotalAmount,
        merchantDiscountPercentage: new PercentDto(0.0),
        totalAmount: simulatorCondition.totalAmount,
        insurance: simulatorCondition.insurance,
      };
      return condition;
    });
    super(conditions);
  }

  public static getInsuranceType(conditions: AutoLoanConditions[]): boolean {
    return conditions.some((condition) => condition.insurance?.type);
  }

  public static getInsuranceProvider(conditions: AutoLoanConditions[]): boolean {
    return conditions.some((condition) => condition.insurance?.provider);
  }

  public getCandidateConditions(): AutoLoanConditions {
    return super.getCandidateConditions() as AutoLoanConditions;
  }

  protected getBestCandidateConditions(): AutoLoanConditions {
    return this.conditions[0];
  }

  public providerNames(): LenderName[] {
    return [
      ...new Set(this.conditions.map((condition) => condition.providerName).filter((providerName) => !!providerName)),
    ];
  }

  public get discount(): MoneyDto | undefined {
    return this.simulatorConditions[0]?.discount;
  }
}
